// extracted by mini-css-extract-plugin
module.exports = {"title":"SectionTitle_title__Z1t8H","divider":"SectionTitle_divider__f7fKN"};